import type React from 'react';

export const NoContent: React.FC = () => {
  return (
    <div className="mt-24 text-md text-black-1">
      お探しの条件に合うES・体験記はありませんでした。
      <br />
      検索条件を変更してください。
    </div>
  );
};
